import styled from "styled-components";

export const Container = styled.div<{ whiteBackground?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 48px 10%;
  background-color: ${({ whiteBackground }) => (whiteBackground ? 'white' : 'var(--gray100)')}}
`;
